<template>
    <div class="auditable-set-project" :class="{ 'errors' : errors }">
        <field-input v-model="form.query" :readonly="!isWritable" placeholder="Project Number" @keyup="verify()" :maxlength="10"></field-input>
        <div class="project-info" v-if="project">
            <div class="item">
                <b>Name:</b>
                <span class="text-muted" v-text="project.name"></span>
            </div>
            <div class="item" v-if="project.is_started">
                <b>Address:</b>
                <div class="text-muted">
                    <span v-text="project.address"></span><br>
                    <span v-text="project.county.name"></span><br>
                    <span v-text="`${project.city} ${project.county.state.short_name}, ${project.zip}`"></span>
                </div>
            </div>
            <div class="item">
                <b>Status:</b>
                <span class="text-muted" v-text="project.status"></span>
            </div>
            <div class="mt-4 mb-4">
                <a class="btn btn-sm btn-info" target="_blank" :href="`/projects/${project.slug}/summary/preview`">Status Report File</a>
            </div>
        </div>
        <a v-if="auditableItem.project && authorize('admin')"
           class="btn btn-sm btn-default btn-with-icon"
           target="_blank"
           :href="`/projects/${auditableItem.project.slug}`">
            <i class="fa fa-external-link-alt"></i>
        </a>
    </div>
</template>
<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            readonly: {
                type: Boolean,
                required: false,
                default: false,
            },
            prefixUrl: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                auditableItem: this.value,
                project: this.value.project,
                errors: false,
                form: new Form({
                    query: this.value.project ? this.value.project.number : '',
                }, false)
            }
        },

        methods: {

            verify: _.debounce(function () {
                if (!this.readyonly) {
                    this.form.post(`${this.prefixUrl}/uncompleted-projects-for/${this.auditableItem.technician.slug}`).then(response => {
                        this.errors = response.projects.length == 0;
                        this.project = null;
                        if (!response.available) {
                            Toast.error(`The Technician doesn't have uncompleted projects`);
                            return;
                        }
                        if (!response.projects.length) {
                            Toast.error(`No projects found with number "${this.form.query}"`);
                            return;
                        }
                        if (response.projects.length == 1 && (this.form.query == response.projects[0].number)) {
                            this.saveProject(response.projects[0])
                        }
                    });
                }
            }, 500),

            saveProject(project) {
                this.project = project;
                this.$emit('project', project)
                if (this.auditableItem.id) {
                    axios.patch(`/field-audits/${this.auditableItem.number}`, {project_id: this.project.id})
                        .then(response => {
                            App.bus.$emit('auditable-project-set', {
                                project: project
                            })
                        })
                }
            }
        },

        computed: {
            isWritable() {
                if (this.auditableItem.is_passed) return false;
                return !this.readonly;
            }
        }
    }
</script>
